export const ICLFaultType = {
  Mechanical: '1MEC',
  ExternalInfluence: '2EXT',
  MaterialFailure: '3MAT',
  ElectricalFailure: '4ELC',
  InstrumentationFailure: '5INS',
  Miscellaneous: '6MSC',
} as const;
export type ICLFaultType = (typeof ICLFaultType)[keyof typeof ICLFaultType];
